import { Button, Modal } from 'semantic-ui-react';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import weddingRequestService from 'src/services/api/weddingRequestService';
import PendingWeddingRequestGroupRow from 'src/components/common/rows/PendingWeddingRequestGroupRow';
import { adminTableStyles } from 'src/assets/styles/components/AdminTable';
import { TableContainerComponent } from 'src/assets/styles/components/Table';
import Swal from 'sweetalert2';
import {
  useRecaptchaToken,
  isCaptchaRequired,
  RECAPTCHA_SECURITY_ERROR,
} from 'src/components/helpers/recaptchaUtils';

const PendMemTableComponent = styled('div')`
  ${adminTableStyles}
  @media only screen and (max-width: 600px) {
    padding: 0;
    .date {
      display: none;
    }
  }
`;

const PendingWeddingRequestMembersOnGroup = (props) => {
  const { group_id } = props;
  const [open, set_open] = useState(false);
  const [loading, set_loading] = useState(true);
  const [allWeddingRequests, set_allWeddingRequests] = useState([]);
  const getCaptchaToken = useRecaptchaToken('wedding_requests_by_group');

  const getInfo = async () => {
    set_loading(true);

    const captchaRequired = isCaptchaRequired();
    const captcha = await getCaptchaToken({ skip: !captchaRequired });
    if (captchaRequired && !captcha) {
      set_loading(false);
      Swal.fire(RECAPTCHA_SECURITY_ERROR);
      return;
    }

    const body = {
      group_id,
      ...(captchaRequired ? { captcha } : {}),
    };
    weddingRequestService
      .getAllWeddingRequestsByGroup(body)
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          set_allWeddingRequests([
            ...response.data.herWeddingRequest,
            ...response.data.hisWeddingRequest,
          ]);
        } else {
          set_loading(null);
        }
      })
      .catch((error) => {
        set_loading(false);
      });
  };

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <>
      {!!allWeddingRequests.length && (
        <Button color="black" onClick={() => set_open(true)}>
          Solicitudes de matrimonio
        </Button>
      )}
      <Modal size="large" onClose={() => set_open(false)} open={open}>
        <Modal.Header>Personas de tu grupo interesadas en casarse</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <PendMemTableComponent>
              <p>
                A continuación tienes la lista de cada miembro de tu grupo que tiene una solicitud
                pendiente de matrimonio.
              </p>
              <TableContainerComponent>
                <table>
                  <thead>
                    <tr>
                      <th className="date">Fecha inscripción</th>
                      <th>Teléfono El</th>
                      <th>Nombre El</th>
                      <th>Teléfono Ella</th>
                      <th>Nombre Ella</th>
                      <th>Aprobar</th>
                      <th>Rechazar</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allWeddingRequests.length ? (
                      allWeddingRequests.map((request) => (
                        <PendingWeddingRequestGroupRow
                          request={request}
                          set_loading={set_loading}
                          loading={loading}
                          getInfo={getInfo}
                          group_id={group_id}
                        />
                      ))
                    ) : (
                      <p>No tienes más personas pendientes por matrimonio</p>
                    )}
                  </tbody>
                </table>
              </TableContainerComponent>
            </PendMemTableComponent>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => set_open(false)}>Cerrar</Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default PendingWeddingRequestMembersOnGroup;
